// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    {{#if showLabel}}
        <terceraLabel text="{{.label}}" visible="{{visible}}" />
    {{/if}}

    <div class="oe-selector-right">
        <terceraTextBox name="OEComment"
                        text="{{.userComment}}"
                        maxLength="{{.maxLength}}" 
                        haveError="{{error != ''}}"
                        tooltip="{{tooltip}}"/>
    </div>
</div>`;
// Exports
export default code;